/**
 * Expects an ISO datetime string of the form "2026-01-05T09:47:43.000Z" and will convert this
 * to a string in classic German format, e.g. "05.01.2026, 10:47:43". This includes a conversion
 * from UTC to the current local German timezone.
 */
export function reformatDate(isoString: string): string {
  return new Date(isoString).toLocaleString("de-DE", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
  });
}
